import type React from "react";

import type { AdminTicketDetailedListItemDto } from "@/api/types";
import { Building01Icon } from "@/components/Icons/Building01Icon";
import { Building04Icon } from "@/components/Icons/Building04Icon";
import { User01Icon } from "@/components/Icons/User01Icon";
import { TableVisualIndicator } from "@/design-system/Table/TableVisualIndicator";

function getVisibilityOptionIcon(visibility: string): React.ReactNode {
  switch (visibility) {
    case "private":
      return <User01Icon size={16} />;
    case "sharedWithBuilding":
      return <Building01Icon size={16} />;
    case "sharedWithCommunity":
    default:
      return <Building04Icon size={16} />;
  }
}

interface TicketVisibilityIndicatorProps {
  type: AdminTicketDetailedListItemDto["visibility"];
}

export function TicketVisibilityIndicator({ type }: TicketVisibilityIndicatorProps): React.ReactNode {
  return <TableVisualIndicator>{getVisibilityOptionIcon(type)}</TableVisualIndicator>;
}
